import { addDays, isAfter } from "date-fns"
import { BillingModel } from "../../billing/models/BillingModel"

export class SubscriberBillingModel {
    amount: number = 0
    dueDate: string = ""
    paymentDate: string = ""
    canceledAt: string = ""
    idBillet: string = ""
    idInvoice: string = ""
    billetUrl: string = ""
    invoiceUrl: string = ""
    billings: BillingModel[] = []

    constructor(s?:Partial<SubscriberBillingModel>) {
        Object.assign(this, s)   

        this._parseBillings()
    }

    hasBillet():boolean {
        return !!this.idBillet
    }

    hasInvoice():boolean {
        return !!this.idInvoice
    }

    hasBeenPaid():boolean {
        return !!this.paymentDate
    }

    hasBeenCanceled():boolean {
        return !!this.canceledAt
    }

    isOverdue():boolean {
        if (!this.dueDate) {
            return false
        }

        if (this.hasBeenPaid()) {
            return false
        }

        const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
        let dueDate = addDays(new Date(this.dueDate), 1) 
        dueDate = new Date(new Date(dueDate).getFullYear(), new Date(dueDate).getMonth(), new Date(dueDate).getDate())

        return isAfter(today, dueDate)
    }


    private _parseBillings():void {
        this.billings = (this.billings || []).map((b) => new BillingModel(b))
    }
}
